import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getLocaleFromPathname } from '@/lib/localeRoutes';

/**
 * Keeps i18next synchronized during client-side navigation. Static generation
 * selects the language before rendering in main.tsx.
 * The route `/` (no prefix) implies English; `/tr/…`, `/de/…`, etc. override.
 * Routes are declared as static paths (e.g. `/tr/how-it-works`) rather than
 * with a `:locale` param, so we parse the first pathname segment directly.
 */
export function LocaleRoute({ children }: { children: React.ReactNode }) {
  const { pathname } = useLocation();
  const { i18n } = useTranslation();
  useEffect(() => {
    const target = getLocaleFromPathname(pathname);
    if (i18n.language !== target) void i18n.changeLanguage(target);
  }, [pathname, i18n]);
  return <>{children}</>;
}
